import { Card } from "@/ui/components/primitives/card";
import { LucideIcon } from "lucide-react";
import { cn } from "@/ui/components/primitives/utils";

interface MetricCardProps {
  title: string;
  value: string;
  change?: string;
  changeType?: "positive" | "negative" | "neutral";
  icon: LucideIcon;
  iconColor?: string;
  className?: string;
}

export function MetricCard({
  title,
  value,
  change,
  changeType = "neutral",
  icon: Icon,
  iconColor = "text-primary",
  className,
}: MetricCardProps) {
  return (
    <Card className={cn("p-6", className)}>
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">{title}</p>
          <p className="text-2xl font-semibold">{value}</p>
          {change && (
            <p
              className={cn(
                "text-sm",
                changeType === "positive" && "text-success",
                changeType === "negative" && "text-destructive",
                changeType === "neutral" && "text-muted-foreground"
              )}
            >
              {change}
            </p>
          )}
        </div>
        <div
          className={cn(
            "h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center",
            iconColor
          )}
        >
          <Icon className="h-6 w-6" strokeWidth={1.5} />
        </div>
      </div>
    </Card>
  );
}
